// extracted by mini-css-extract-plugin
module.exports = {"author":"author_author__2fAQj"};